<template>
  <div class="stickers-tabs">
    <div class="stickers-tabs__items">
      <button
        class="stickers-tabs__item"
        v-for="item in tabs"
        :key="item.value"
        :class="{ 'stickers-tabs__item--active': item.value === tab }"
        type="button"
        @click.prevent="handleClick(item)"
      >
        <UseSvg :icon="item.icon" width="24" height="24" class="stickers-tabs__icon" />
        {{ item.label }}
      </button>
    </div>
    <slot :tab="tab"></slot>
  </div>
</template>

<script setup>
import { ref } from "vue";
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";

const props = defineProps({
  tabs: { type: Array, required: true },
  artwork: { type: Object, required: true }
});

const tab = ref(props.tabs[0].value);

const handleClick = item => {
  if (props.artwork.processingImage) return;

  tab.value = item.value;
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/jiffy/settings";

.stickers-tabs {
  &__items {
    display: flex;
    justify-content: center;
    gap: 12px;
    border-radius: 8px;
    background: $crafterpay-gray-modern-800;
    padding: 6px;

    @include with-desktop {
      gap: 40px;
    }
  }

  &__item {
    min-height: 60px;
    appearance: none;
    border: none;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 8px;
    padding: 6px 4px;
    color: $white;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.3;
    border-radius: 8px;
    background: transparent;
    flex-grow: 1;

    &--active,
    &:hover {
      color: $primary-600;
      background-color: $white;
    }
  }

  &__icon {
    width: 24px;
    height: 24px;
  }
}
</style>
